const SlackIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_349_15099)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.86632 0C4.98186 0.000652396 4.26606 0.716983 4.26671 1.59967C4.26606 2.48236 4.98251 3.1987 5.86697 3.19935H7.46723V1.60033C7.46789 0.717635 6.75143 0.00130479 5.86632 0C5.86697 0 5.86697 0 5.86632 0ZM5.86632 4.26667H1.60026C0.715805 4.26732 -0.000651915 4.98365 1.78649e-06 5.86634C-0.00130562 6.74903 0.715151 7.46536 1.59961 7.46667H5.86632C6.75078 7.46601 7.46723 6.74968 7.46658 5.86699C7.46723 4.98365 6.75078 4.26732 5.86632 4.26667Z'
          fill='#36C5F0'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M16 5.86634C16.0007 4.98365 15.2842 4.26732 14.3998 4.26667C13.5153 4.26732 12.7989 4.98365 12.7995 5.86634V7.46667H14.3998C15.2842 7.46601 16.0007 6.74968 16 5.86634ZM11.7333 5.86634V1.59967C11.734 0.717635 11.0182 0.00130479 10.1337 0C9.24925 0.000652396 8.5328 0.716983 8.53345 1.59967V5.86634C8.53214 6.74903 9.2486 7.46536 10.1331 7.46667C11.0175 7.46601 11.734 6.74968 11.7333 5.86634Z'
          fill='#2EB67D'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.133 16C11.0174 15.9994 11.7339 15.2831 11.7332 14.4004C11.7339 13.5177 11.0174 12.8013 10.133 12.8007H8.53272V14.4004C8.53206 15.2824 9.24852 15.9987 10.133 16ZM10.133 11.7327H14.3997C15.2841 11.7321 16.0006 11.0157 15.9999 10.133C16.0013 9.25035 15.2848 8.53402 14.4003 8.53271H10.1336C9.24917 8.53337 8.53272 9.2497 8.53337 10.1324C8.53272 11.0157 9.24852 11.7321 10.133 11.7327Z'
          fill='#ECB22E'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.46976e-07 10.1331C-0.000653255 11.0158 0.715804 11.7321 1.60026 11.7328C2.48472 11.7321 3.20118 11.0158 3.20052 10.1331V8.53345H1.60026C0.715804 8.5341 -0.000653255 9.25043 4.46976e-07 10.1331ZM4.26671 10.1331V14.3998C4.2654 15.2825 4.98186 15.9988 5.86632 16.0001C6.75078 15.9995 7.46723 15.2831 7.46658 14.4004V10.1344C7.46789 9.25173 6.75143 8.5354 5.86697 8.5341C4.98186 8.5341 4.26606 9.25043 4.26671 10.1331Z'
          fill='#E01E5A'
        />
      </g>
      <defs>
        <clipPath id='clip0_349_15099'>
          <rect
            width='16'
            height='16'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SlackIcon
